import * as q from '@Organizations/Users/Domain/queries-vue-composables'

export function useDashboardPage(){
	return {
		useUserDashboardQuery: q.useUserDashboardQueryV1,
	}
}

export function useUserAccessRequestsPage(){
	return {
		useUserAccessRequestsQuery: q.useUserAccessRequestsQueryV1,
	}
}

export function useUserAccessRequestsRejectedPage(){
	return {
		useUserAccessRequestsQuery: q.useUserAccessRequestsQueryV1,
	}
}

